import React from 'react'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import { Link } from 'react-router-dom'

const UwagaComponent = () => {
  return (
    <Card variant='outlined' className='element-card-uwaga'>
      <CardHeader
        avatar={<img src='/img/i-push.png' className='i-push' alt='Ikona push' />}
        title='Aby otrzymywać powiadomienia PUSH dodaj skrót aplikacji na pulpit'
      />
      <Box display='flex' justifyContent='center' mb={2}>
        <Link to='/jak' style={{ textDecoration: 'none' }}>
          <Button
            variant='contained'
            sx={{
              borderRadius: '15px',
              backgroundColor: '#FF0000',
              fontFamily: 'Poppins',
              textTransform: 'none',
              px: 3,
              py: 1
            }}
          >
            Jak dodać skrót na pulpit?
          </Button>
        </Link>
      </Box>
    </Card>
  )
}

export default UwagaComponent
